/* AUTH APIS */
export const LOGIN = "users/login";
export const SUPER_LOGIN = "super-admin/login";
export const SIGN_UP = "users/register";
export const ME = "me";
export const LOGOUT_USER = "users/logout";
export const CHILD_MIGRATE = "users/childMigrate";

/* USER SETTINGS */
export const BOT_APPEARANCE = "bot/appearance";
export const BOT_LISTS = "bot/list";
export const BOT_APPEARANCE_DETAILS = "bot/appearance-details";
export const BOT_QUESTION = "bot/question";
export const KNOWLEDGE_CATAGORY = "bot/ks-category";
export const GENERATE_EMBED = "bot/settings/shortcode";
export const KNOWLEDGE_SOURCE_DOCUMENT = "bot/ks-upload-fs";
export const BOT_SETTINGS = "bot/settings";
export const BOT_SETTINGS_PROPS = "bot/settings-prop";
export const BOT_SETTINGS_PROPS_CHAT = "language-list/";
export const KNOWLEDGE_SOURCE = "bot/ks-upload";
export const BOT_CHAT_ICON = "bot/appearance-img";
export const BOT_CHAT_ICON_REMOVE = "bot/remove-bot-appearance-img";
export const GENERIC_FILE_UPLOAD = "bot/generic-file-upload";
export const BOT_EMBED = "bot/embed";
export const BOT_DELETE = "bot/archive";
export const BOT_CHAT_HISTORY = "chat-bot-history-browser";
export const GOOGLE_CRED_AUTH = "authenticate-google-calender-cred/";
export const TRANSLATED_OUTPUT = "translated-output/";
/* SETTINGS FOR USER */
export const BOT_STATUS_UPDATE = "bot/update-bot-status";
export const BOT_LIST_WITH_STATUS = "bot/all-status";
export const SCHEDULE = "timetable";
export const DELETE_DATE_SCHEDULE = "timetable/remove/date/";
export const DELETE_SLOT_SCHEDULE = "timetable/remove/slot";

/* USER SETTINGS */
export const USER_UPDATE = "users/update";
export const FORGET_PASSWORD = "users/forget_password";
export const GET_OTP = "users/get_otp";
export const VALIDATE_OTP = "users/validate_otp";
export const CHANGE_PASSWORD = "users/reset_password";
export const EMAIL_VERIFICATION_OTP = "users/email_verification_otp";
export const EMAIL_VERIFICATION = "users/email_otp_validate";
export const PHONE_VERIFICATION_OTP = "users/phone_verification_otp";
export const PHONE_VERIFICATION = "users/phone_otp_validate";
export const TOTAL_SUBSCRIBERS = "users/total_subscribers";
export const GET_PARENT_AGENCY_INFO = "users/getCompanyInfo";
export const DASHBOARD_CHAT_DETAILS = "chat-bot-history-details-user";

// APIs from python end
export const CHAT_HISTORY_LIST = "chat-bot-history-list/";
export const CHAT_HISTORY_DETAILS = "chat-bot-analytics/";
export const CHAT_HISTORY_VIEW = "chat-bot-history-view/";
export const CHAT_BOT_SIGNUP = "user-registration/";
export const CHAT_BOT_SIGNIN = "user-login/";
export const CHAT_BOT_FORGOT_PASS = "reset-password/";
export const SAVE_CHAT_HISTORY = "save-chat-history/";
export const CHAT_HISTORY_FETCH = "fetch-chat-history/";
export const CHAT_TRUSTED_DEVICE_CONSENT = "trust-device/";
export const SEND_OTP = "send-chat-bot-otp/";
export const VERIFY_OTP = "verify-chat-bot-otp/";
export const BOT_ACCOUNT_DELETE = "delete-account/";
export const COMMUNICATION_OPTIN = "update-chat-bot-consent/";
export const GOOGLE_OAUTH_URL = "google-oauth-url/";
export const GOOGLE_OAUTH_CALLBACK = "google-oauth-callback/";
export const MS_OAUTH_URL = "microsoft-oauth-url/";
export const MS_OAUTH_CALLBACK = "microsoft-oauth-callback/";
export const CALENDER_EMAIL_LIST = "calendar-email-list/";
export const CALENDER_EMAIL_REMOVE = "calendar-email-remove/";
export const CALENDER_EMAIL_UPDATE = "calendar-email-updateunknown/";
export const BOT_PROCESSING_PROGRESS = "bot-processing-progress/";

// export const REFERRAL_COUNT = "subscription/refer-user-count"
export const GET_SITE_INFO = "users/getSiteInfo";
export const GET_SOCIALMEDIA_INFO = "users/allSocialMedia";
export const CONTACT_US = "contact-us";

/*ADMIN USER SETTINGS */
export const ADMIN_FORGET_PASSWORD = "super-admin/forget_password";
export const ADMIN_GET_OTP = "super-admin/get_otp";
export const ADMIN_VALIDATE_OTP = "super-admin/validate_otp";
export const ADMIN_CHANGE_PASSWORD = "super-admin/reset_password";
export const NOTIFICATION = "users/notification";
export const SAVE_TOKEN = "fcm/token/subscribe";
export const SEND_NOTIFICATION = "fcm/send-notification";
export const EXPORT_USER_DATA = "users/download_user_details";
export const BRANDING_MANAGEMENT = "users/updateCompanyInfo";

export const CARD_DEFAULT_SETUP = "subscription/card-default-setup";
export const CARD_UPDATE = "subscription/card-update";
export const USER_SUBSCRIPTION_LIST = "subscription/user-subscription-list";
export const USER_INVOICE_LIST = "subscription/user-invoice-list";
export const ADMIN_REVENEU_URL = "subscription/get-user-revenue";
export const ADMIN_AFFILIATE_COMISSION_URL = "subscription/affiliate-user-data";

export const CMS_BASE_URL = {
  ALL_USERS: "super-admin/user_lists",
  CREATE_USERS_BY_ADMIN: "super-admin/create_new_user",
  EDIT_USERS_BY_ADMIN: "super-admin/update_user",
  DELETE_USERS_BY_ADMIN: "super-admin/delete_user",
  UPDATE_USERS_STATUS_BY_ADMIN: "super-admin/status_toggle",
  RESTORE_USER_BY_ADMIN: "super-admin/retrieve_user",
  DOWNLOAD_USERS_BY_ADMIN: "super-admin/download_user_lists",
  DOWNLOAD_REVENEU_REPORT: "subscription/downLoad-user-revenue",
  DOWNLOAD_AFFILIATE_COMISSION_REPORT: "subscription/downLoad-user-revenue",
  COUPON: {
    CREATE: "stripe/subscription/create-coupon",
    GET_ALL: "stripe/subscription/coupon-list",
    DELETE: "stripe/subscription/delete-coupon",
  },
  PLAN_DESCRIPTION: {
    CREATE: "subscription/create-plan",
    UPDATE: "subscription/update-plan",
    GET_ALL: "subscription/plan-description-list",
    DELETE: "subscription/delete-coupon",
  },
  PLAN: {
    CREATE: "subscription/create-plan",
    UPDATE: "subscription/update-plan",
    UPDATE_PRICE: "subscription/update-plan-price",
    DELETE_PLAN: "subscription/delete-plan",
    GET_ALL: "subscription/plan-list",
    DELETE: "subscription/delete-coupon",
    GET_BY_ID: "subscription/edit-plan/",
  },
  DASHBOARD: {
    GET_ALL: "subscription/user-plan-list",
    USER_SUBSCRIPTION: "subscription/create-subscription",
    USER_HANDLE_SUBSCRIPTION: "subscription/handle-subscription",
    CHILD_SUBSCRIPTION: "subscription/create-agency-subscription",
    CHILD_HANDLE_SUBSCRIPTION: "subscription/handle-agency-subscription",
    ACTIVE_PLAN: "subscription/user-active-subscription",
    CANCEL_PLAN: "subscription/cancel-subscription",
    ALL_ACTIVE_SUBSCRIBED_USER:
      "subscription/superadmin-user-subscription-list",
    DOWNLOAD_INVOICE: "subscription/download-invoice",
    DASHBOARD_ANALYTICS: "users/dashboard_analytics",
    REPLICATE_PLAN: "subscription/add-existing-dc-plan",
    PAY_INVOICE: "subscription/payInvoice",
    SUBSCRIPTION_EXPORT: "subscription/superadmin-user-subscription-export",
  },
  CMS: {
    CREATE: "cms",
    UPDATE: "cms/",
    GET_ALL: "cms/type/",
    DELETE: "cms/",
    GET_BY_ID: "cms/",
    DELETE_FILE: "cms/file",
  },
};

export const GO_HIGH_LEVEL = {
  CONFIG: "oauth/ghl/config",
  AUTHORIZE: "oauth/authorize/",
  CALLBACK: "oauth/callback",
};

export const INTENT = {
  CREATE: "subscription/create-stripe-account",
  UPDATE: "subscription/update-stripe-account",
  GET: "subscription/get-stripe-account",
  ONBOARDING: "subscription/complete-userOnboarding",
};

export const AFFILIATE_SUBSCRIPTION = {
  EARNING_BY_DATE_RANGE: "subscription/affiliate-earning-dateRange",
  EARNING_DETAILS: "subscription/affiliate-earning-details",
  TRANSFER_LIST: "subscription/affiliate-transfer-list",
  EXPORT_CSV: "subscription/export-affiliate-user-data",
};

export const AFFILIATE_ACTIVITY = {
  SEND_REFERRAL_LINK: "users/send-referral-link",
  REFERRALS_LIST: "users/referrals-list", //?page=null&limit=null&search=null&status=null&fromDate=null&toDate=null
  ACCEPT_INVITATION: "users/accept-referral-invitation",
};

//ROUTE API MODEL
export const ALL_ROUTER_MODEL = "openrouter-model-list/";
export const ROUTER_MODEL_CRUD = {
  LIST: "super-admin/getOpenRouterBaseModelList",
  ADD: "super-admin/addOpenRouterBaseModel",
  EDIT: "super-admin/editOpenRouterBaseModel",
  DELETE: "super-admin/deleteOpenRouterBaseModel",
};

export const ROLE_LIST = "users/role_lists";
export const ROLE_ADD_UPDATE = "users/role";
export const ROLE_DETAILS = "users/role_details";

export const AGENCY_USER_ACTIVITY = "users/agency/userlist";
export const DOWNLOAD_AGENCY_USER_ACTIVITY =
  "super-admin/download_agency_activities";

export const CHATBOT_CONTACT_LIST = "chat-bot-contact-list";
export const CHATBOT_CONTACT_LIST_EXPORT_CSV = "chat-bot-contact-list-export";
export const CHATBOT_VISITOR_CONTACT_LIST_EXPORT_CSV =
  "chat-bot-contact-list-export-visitor";
export const MERGE_CONTACTS = "users/merge/merge-contact";

export const CHAT_HISTORY_LIST_EXPORT = "chat-bot-history-txt-file";
export const CHAT_HISTORY_BULK_EXPORT = "chat-bot-history-zip-file";

// bot compliances
export const BOT_COMPLIANCE = {
  get: "bot/complian-check-user",
  create: "bot/createCompliance",
  get_own_list: "bot/getComplianceByUser",
  get_All_list: "bot/getAllUsersCompliancesByAdmin",
};

//prompt & Q&A
export const QNA = "bot/qna";
export const PROMPT = "bot/prompt";
export const SAMPLE_QNA_PROMPT_UPLOAD = "bot/sample-pqa-file-upload";
export const SAMPLE_QNA_PROMPT_GET = "bot/sample-pqa-file-latest?file_type=";
export const SAMPLE_QNA_PROMPT_DOWNLOAD = "bot/sample-pqa-file-download";

export const QUOTATION = "quote";

export const CURRENCY_EXCHANGE_RATE = "currency";
export const USER_MESSAGE_USAGE = "user_message_usage/";
